import React, { memo, useCallback } from "react";

interface ReportImageProps {
  src: string;
  alt: string;
  index: number;
}

const ReportImage: React.FC<ReportImageProps> = memo(({ src, alt, index }) => {
  const handleImageError = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      const target = e.target as HTMLImageElement;
      target.src =
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDIwMCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTUwIiBmaWxsPSIjRjhGOUZBIi8+CjxwYXRoIGQ9Ik01MCA1MEw4MCA5MEwxMjAgNTBMMTUwIDEyMEg1MFY1MFoiIGZpbGw9IiNERUUyRTYiLz4KPGNpcmNsZSBjeD0iNzAiIGN5PSI3MCIgcj0iOCIgZmlsbD0iI0RFRTJFNiIvPgo8L3N2Zz4K";
      target.style.objectFit = "contain";
      target.style.background = "#F7F6EF";
    },
    []
  );

  return (
    <img
      src={src}
      alt={alt}
      className="report-image"
      onError={handleImageError}
      loading="lazy"
    />
  );
});

ReportImage.displayName = "ReportImage";

export default ReportImage;
